import { Area, UserAttributeDefs } from '@iotv/datamodel-core'
import { Position } from '@iotv/iotv-v3-types'

const typeName = 'SoilMoistureArea'

export type SoilMode = 'moisture' | 'temperature'
export type BandKeys = 'upBand' | 'downBand'
export type BandDepthState = {
  [key: number]: BandPair | undefined
}
export type BandPair = {
  [k in BandKeys]?: number
}
export type BandState = {
  [k in SoilMode]?: BandDepthState
}
//  Record<SoilMode, Record<number, BandPair>>;

type SoilMositureAreaProps = {
  // areaType:
  name: string
  points: Position[]
  soilType: string
  soilRisk: string
  soilFieldCapacity?: number
  soilStressPoint?: number
  bands?: BandState
}

export class SoilMoistureArea extends Area implements SoilMositureAreaProps {
  // extends DeviceEnabledType<SupportedDevices> {
  constructor(ob?: any) {
    super({ ...ob })

    // super(typeName, { ...ob });
    this.name = ob.name
    this.points = ob.points
    this.soilType = ob.soilType
    this.soilRisk = ob.soilRisk
    this.soilFieldCapacity = ob.soilFieldCapacity
    this.soilStressPoint = ob.soilStressPoint
    this.bands = ob.bands
  }

  name: string
  points: Position[]
  soilType: string
  soilRisk: string
  soilFieldCapacity?: number
  soilStressPoint?: number
  bands?: BandState

  getUserAttributes(): UserAttributeDefs {
    return {
      name: {
        type: 'String',
        editable: true,
        default: false,
        label: 'Name',
        required: true,
      },
      soilType: {
        type: 'String',
        editable: true,
        label: 'Soil Type',
        name: 'Soil Type',
        // required: true,
      },
      soilRisk: {
        type: 'String',
        editable: true,
        label: 'Soil Risk',
        name: 'Soil Risk',
        // required: true,
      },
      soilFieldCapacity: {
        type: 'String',
        editable: true,
        label: 'Soil Field Capacity (%)',

        required: false,
      },
      soilStressPoint: {
        type: 'String',
        editable: true,
        label: 'Soil Stress Point (%)',

        required: false,
      },
    }
  }
}
